import React from "react";
import PropertySearch from "./propertySearch/PropertySearch";
import "./Home.css";

function Home() {
  return (
    <div>
      <PropertySearch />
    </div>
  );
}

export default Home;
